import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component PersonArrowOutCircleIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <PersonArrowOutCircleIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <PersonArrowOutCircleIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const PersonArrowOutCircleIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    svgRef?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="PersonArrowOutCircleIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2c.338 0 .672.017 1.001.05L13 3.5c0 .19.008.38.024.566a8 8 0 00-6.883 13.38A3.987 3.987 0 018.122 16.4 19.252 19.252 0 0112 16c1.292 0 2.585.133 3.877.398.76.156 1.444.525 1.983 1.048A7.97 7.97 0 0020 12c0-.69-.087-1.36-.252-2H21.8c.131.646.2 1.315.2 2a9.968 9.968 0 01-2.85 6.99l-.224.223-.329.302-.325.274-.353.272-.314.222-.345.223A9.953 9.953 0 0112 22a9.954 9.954 0 01-4.951-1.31l-.33-.197-.324-.21-.374-.266-.137-.105-.223-.177-.293-.25-.295-.273A9.971 9.971 0 012 12C2 6.477 6.477 2 12 2zm0 16c-1.157 0-2.315.119-3.476.357a1.999 1.999 0 00-.831.385A7.958 7.958 0 0012 20a7.963 7.963 0 004.307-1.257 1.983 1.983 0 00-.832-.386A17.253 17.253 0 0012 18zm0-11a4 4 0 110 8 4 4 0 010-8zm0 2a2 2 0 100 4 2 2 0 000-4zm6-8v3h-3v2h3v3l5-4-5-4z"
      />
    </svg>
  )
);
PersonArrowOutCircleIcon.displayName = "PersonArrowOutCircleIcon";
export default PersonArrowOutCircleIcon;
